import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`Hi, I'm Maxwell Abrams`}</h1>
    <p>{`I'm currently a Principal Software Development Engineer with Amazon. `}</p>
    <p>{`Want to chat? Let's connect on `}<a parentName="p" {...{
        "href": "https://www.linkedin.com/in/maxwellabrams/"
      }}>{`LinkedIn`}</a>{`.`}</p>
    <p>{`Want to learn more? Keep scrolling!`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      